import { ApprovalFlow } from "../types/collab-docs";
import { AnswerSetCommentVisibility } from "../types/collab-docs/AnswerSetCommentVisibility";
import { SavedCommentDto } from "../types/dtos/forms";
import { EnabledModuleConfig } from "../types/dtos/users/SignedInUserClientDetails";

/** Journeys module config. False keeps new comments on Private. */
export const DEFAULT_NEW_COLLAB_COMMENT_TO_SHARED_KEY =
  "DefaultNewCollabCommentToShared";

export const commentsHelper = {
  allowCommentVisibilityModeChange: (
    isInPrepMode: boolean,
    approvalFlow: ApprovalFlow
  ) => {
    if (isInPrepMode || approvalFlow === "HIDDEN-TO-EMPLOYEE") {
      return false;
    }

    return true;
  },
  getUnseenCommentCount: (
    comments: SavedCommentDto[] | null,
    loggedInUserId: number
  ) => {
    return comments
      ? comments.filter(
          (x) =>
            !x.seen &&
            x.authorId !== loggedInUserId &&
            x.commentType === "STANDARD"
        ).length
      : 0;
  },
  /**
   * Initial visibility for a new collab comment. Locked forms stay Private.
   * When the toggle is shown, Shared is used only if the client config is true.
   */
  defaultNewCommentVisibility: (
    moduleConfigs: EnabledModuleConfig[],
    allowCommentVisibilityModeChange: boolean
  ): AnswerSetCommentVisibility => {
    if (!allowCommentVisibilityModeChange) {
      return "PRIVATE";
    }

    const defaultToShared = moduleConfigs.some(
      (config) =>
        config.key === DEFAULT_NEW_COLLAB_COMMENT_TO_SHARED_KEY &&
        config.value.trim().toLowerCase() === "true"
    );

    return defaultToShared ? "SHARED" : "PRIVATE";
  },
};

export default commentsHelper;
